<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.deadline.$anyError }"
        >
          <label for="date" class="form__label uk-hidden">Deadline</label>
          <date-picker
            v-model.trim="form.deadline"
            format="DD.MM.YYYY"
            class="uk-width-1-1"
            :editable="false"
            :disabled-date="disabledDates"
            :default-value="defaultDate"
            @input="invokeTouch($v.form.deadline)"
          >
            <template v-slot:icon-calendar>
              <img data-uk-svg src="@/assets/images/calendar.svg" alt="logo" />
            </template>
          </date-picker>
          <span class="form__error-message form__error-message--no-label">
            <template v-if="!$v.form.deadline.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import stepValidation from '../../mixins/stepValidation';
import BriefStep from '../global/BriefStep.vue';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pl';

export default {
  name: 'Deadline',
  components: { BriefStep, DatePicker },
  mixins: [stepValidation],
  data: () => ({
    title:
      // eslint-disable-next-line operator-linebreak
      'Doskonale wiemy, że każdego gonią deadline’y. Kiedy chciałbyś cieszyć ' +
      'się gotową stroną? *',
    form: {
      deadline: '',
    },
    defaultDate: new Date(Date.now() + 2678400000), // 31 days
  }),
  validations: {
    form: {
      deadline: {
        required,
      },
    },
  },
  methods: {
    disabledDates(date) {
      // + 30 days
      return date < new Date(Date.now() + 2592000000);
    },
  },
};
</script>
<style lang="scss">
.brief-form {
  .mx-datepicker {
    width: 100% !important;

    .mx-icon-calendar {
      right: unset;
      left: rem(20px);
      color: $purple;
      display: block !important;

      svg {
        height: rem(24px);
        width: rem(24px);
      }
    }

    .mx-icon-clear {
      display: none !important;
    }

    .mx-input {
      border-radius: $border-radius;
      border: rem(1px) solid $white;
      background-color: $white;
      padding: rem(19px 30px 19px 60px);
      font-size: 0.938rem;
      color: $purpleDim;
      transition: $t-border-color, $t-background-color;
      height: auto;
      line-height: unset;
      box-shadow: none;

      @include hover {
        outline: none;
        border-color: $purple;
        cursor: pointer;
      }
    }
  }

  .error {
    .mx-input {
      border-color: $danger;
    }
  }
}

.mx-datepicker-popup {
  margin-top: -2px !important;
  border-radius: 0.3125rem !important;
}

.mx-calendar {
  padding: 0 !important;

  @include media-min($sm) {
    width: 400px !important;
  }

  @include media-min($lg) {
    width: 300px !important;
  }

  @include media-min($xl) {
    width: 400px !important;
  }
}

.mx-datepicker-main {
  color: #000 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  font-family: inherit;

  .mx-btn {
    color: #000 !important;
  }
}

.mx-calendar-header {
  padding: 6px 12px !important;
  color: $white;
  background-color: $purple;
  height: auto !important;

  @include media-min($sm) {
    padding: 20px !important;
  }

  @include media-min($lg) {
    padding: 12px !important;
  }

  @include media-min($xl) {
    padding: 20px !important;
  }

  .mx-btn {
    color: $white !important;
    font-size: 16px !important;

    @include media-min($lg) {
      font-size: 14px !important;
    }

    @include media-min($xl) {
      font-size: 20px !important;
    }
  }

  .mx-icon-left::before,
  .mx-icon-right::before,
  .mx-icon-double-left::before,
  .mx-icon-double-right::before,
  .mx-icon-double-left::after,
  .mx-icon-double-right::after {
    border-width: 3px 0 0 3px !important;
  }
}

.mx-calendar-content {
  height: auto !important;
  padding: 12px 12px 6px !important;

  .cell {
    transition: $t-color, $t-background-color !important;
    border-radius: 50px;

    @include media-min($sm) {
      height: 53.7px !important;
    }

    @include media-min($lg) {
      height: 39.42px !important;
    }

    @include media-min($xl) {
      height: 53.7px !important;
    }

    &:hover {
      color: $white !important;
      background-color: $purple !important;
    }

    &.active {
      background-color: $purple !important;
    }

    &.disabled {
      background-color: transparent;

      &:hover {
        background-color: transparent;
        color: #ccc !important;
      }
    }

    &.today {
      color: $purple !important;
    }
  }
}

.mx-table-date {
  td,
  th {
    @include media-min($sm) {
      font-size: 15px !important;
    }

    @include media-min($lg) {
      font-size: 12px !important;
    }

    @include media-min($xl) {
      font-size: 15px !important;
    }
  }
}
</style>
